import { trigger, transition, animate, style } from '@angular/animations';

export const enterComponent = (delay: number = 500) => trigger('enterComponent', [
    transition(':enter', [
        style({
            opacity: 0,
        }),
        animate(`.5s ${delay}ms`, style({
            opacity: 1
        }))
    ]),
]);
